import { Element_ } from "./Element_";
import { Directive } from "@angular/core";

@Directive()
export class Question extends Element_ {
  constructor() {
    super();
  }
}
